import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import DragHandleIcon from "@mui/icons-material/DragHandle";

const ReadyMadeYoghurtList = () => {
  const navigate = useNavigate();

  const yoghurtItems = [
    {
      id: 1,
      img: "/static/images/placeholder.png",
      flavor:"Mango",
      name: "Classic Greek Yoghurt",
      quantity: "200g Cup",
      toppings: "Honey, Almonds",
      description: "Rich creamy Greek yoghurt with natural sweetness.",
      price: " KD 120",
      tax: "5%",
      visible: true,
    },
    {
      id: 2,
      img: "/static/images/placeholder.png",
            flavor:"Kiwi",

      name: "Berry Blast Yoghurt",
      quantity: "150g Cup",
      toppings: "Blueberry, Strawberry",
      description: "Refreshing yoghurt topped with fresh berries.",
      price: " KD 150",
      tax: "5%",
      visible: false,
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>

            <TableCell>Title</TableCell>

            <TableCell>Quantity</TableCell>
            <TableCell>Toppings</TableCell>
            <TableCell>Flavor</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Tax</TableCell>
            <TableCell>Restrict Redemption</TableCell>
            <TableCell>Enable / Disable</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {yoghurtItems.map((item) => (
            <TableRow hover key={item.id}>


              <TableCell>
                <Box component="a" className="user_block click_action" onClick={() => navigate('/manage-promotions/view')}>
                  <figure className="no_radius">
                    <img src={item.img} alt={item.name} />
                  </figure>
                  <p>
                    <b>{item.name}</b>
                  </p>
                </Box>
              </TableCell>


              <TableCell>{item.quantity}</TableCell>
              <TableCell>{item.toppings}</TableCell>
              <TableCell>{item.flavor}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>{item.price}</TableCell>
              <TableCell>{item.tax}</TableCell>

              <TableCell>
                <SwitchToggle defaultChecked={item.visible} />
              </TableCell>
              <TableCell>
                <SwitchToggle defaultChecked={item.visible} />
              </TableCell>

              <TableCell>
                <div className="table_actions v2">
                  <IconButton
                    onClick={() =>
                      navigate("/manage-readymade-yoghurt/view", { state: item })
                    }
                  >
                    <img src="/static/images/eye_icon.svg" alt="View" />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      navigate("/manage-readymade-yoghurt/add", { state: item })
                    }
                  >
                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                  </IconButton>

                  <IconButton>
                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                  </IconButton>
                </div>
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReadyMadeYoghurtList;
